import React from 'react'
import PropTypes from 'prop-types'
import Head from 'next/head'
import { assetPrefix } from '../../stv.config.js'
import faviconMain from '../../assets/favicons/favicon.svg'
import favicon from '../../assets/favicons/favicon.ico'
import favicon180 from '../../assets/favicons/apple-touch-icon.png'
import { formatUrl } from '../../utils/browser'

const MetaData = ({
  title = 'STV Player | Everything that’s on STV plus a whole lot more',
  description = 'Gripping drama box sets, eye-opening documentaries, true crime and absolute classics.  STV Player, TV you’ll love for free.',
  image = 'https://files.stv.tv/img/player/social-logo-1024x576.png',
  summary = '',
  currentUrl = 'https://player.stv.tv/',
  canonical = '',
}) => (
  <Head>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="author" content="" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    <link rel="canonical" href={formatUrl(canonical || currentUrl)} />

    <link rel="icon" href={faviconMain} type="image/svg+xml" />
    <link rel="alternate icon" sizes="16x16" href={favicon} />

    <link rel="apple-touch-icon-precomposed" sizes="180x180" href={favicon180} />

    <meta name="application-name" content="STV Player" />
    <meta name="msapplication-tooltip" content="STV Player" />
    <meta name="msapplication-config" content={`${assetPrefix}/favicons/ieconfig.xml`} />

    <meta property="fb:app_id" content="167069041547" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={summary === '' ? description : summary} />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://player.stv.tv/" />
    <meta property="og:image" content={image} />
    <meta property="og:site_name" content="STV Player" />

    {currentUrl.includes('/search') && (
      <meta name="robots" content="noindex" />
    )}

    <meta name="twitter:widgets:theme" content="dark" />
    <meta name="twitter:card" content="app" />
    <meta name="twitter:site" content="@wearestv" />
    <meta name="twitter:url" content="https://player.stv.tv/" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />
    <meta name="twitter:image:alt" content={title} />

    <meta name="twitter:app:country" content="GB" />
    <meta name="twitter:app:name:iphone" content="STV Player" />
    <meta name="twitter:app:id:iphone" content="508100323" />
    <meta name="twitter:app:url:iphone" content="stv-player://" />
    <meta name="twitter:app:name:ipad" content="STV Player" />
    <meta name="twitter:app:id:ipad" content="508100323" />
    <meta name="twitter:app:url:ipad" content="stv-player://" />
    <meta name="twitter:app:name:googleplay" content="STV Player" />
    <meta name="twitter:app:id:googleplay" content="tv.stv.android.player" />
    <meta name="twitter:app:url:googleplay" content="https://play.google.com/store/apps/details?id=tv.stv.android.player" />
  </Head>
)

MetaData.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  summary: PropTypes.string,
  currentUrl: PropTypes.string,
  canonical: PropTypes.string,
}
export default MetaData
